import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useMemo } from 'react';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    month: {
      border: `1px solid ${color.$9}`,
      borderRadius: 8,
      fontWeight: '500',
      fontSize: '15px',
      lineHeight: '21px',
      background: color.$7,
      padding: 16,
      width: '100%',
    },
    week: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
    lastWeek: {
      marginBottom: 0,
    },
    day: {
      cursor: 'pointer',
      color: color.$14,
      width: 24,
      height: 24,
      lineHeight: '24px',
      borderRadius: 4,
      textAlign: 'center',
      display: 'inline-block',
    },
    active: {
      background: color.$1,
      color: color.$7,
    },
  },
  {
    name: 'MonthSchedule',
  },
);

const MonthSchedule = ({ data, className, onChange }) => {
  const classes = useStyles();

  const monthComponent = useMemo(() => {
    const days = [];
    for (let i = 1; i <= 31; i += 1) {
      const active = data.includes(i);
      const day = i.toString().padStart(2, '0');

      days.push(
        <div
          key={`MonthSchedule-${day}`}
          className={classnames(classes.day, {
            [classes.active]: active,
          })}
          onClick={() => {
            if (active) {
              onChange([...data.filter(d => d !== i)].sort((a, b) => a - b));
            } else {
              onChange([...data, i].sort((a, b) => a - b));
            }
          }}
        >
          {day}
        </div>,
      );
    }

    const weeks = [];
    for (let i = 0; i < days.length; i += 7) {
      const isLastWeek = i + 7 >= days.length;
      const weekDays = days.slice(i, i + 7);

      // 補滿不足的天數
      while (weekDays.length < 7) {
        weekDays.push(
          <div
            key={`empty-${i}-${weekDays.length}`}
            className={classes.day}
            style={{ cursor: 'auto' }}
          />,
        );
      }

      weeks.push(
        <div
          key={`Week-${i / 7}`}
          className={classnames(classes.week, {
            [classes.lastWeek]: isLastWeek,
          })}
        >
          {weekDays}
        </div>,
      );
    }

    return weeks;
  }, [data]);
  return (
    <div className={classnames(classes.month, className)}>{monthComponent}</div>
  );
};

export default MonthSchedule;
